<app-preloader></app-preloader>
<router-outlet></router-outlet>

